import { HostelApiService } from "../../config/apiServices";

export const getHostelDetail = (userId) => {
    return HostelApiService.get(`/api/user/${userId}/hostelDetail`);
};
